import CompatibilityList from "gatsby-theme-dettol/src/components/CompatibilityList/CompatibilityList"

import "./CompatibilityListOverride.scss"

export default CompatibilityList